import PropTypes from 'prop-types';

import iconShape from '../../../shared/types/icon';

const filterShape = PropTypes.shape({
  emptyMessage: PropTypes.string.isRequired,
  icon: iconShape.isRequired,
  label: PropTypes.string.isRequired,
  listComponent: PropTypes.elementType.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export default filterShape;
